webpackJsonp([170264817138936],{

/***/ 424:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pressList":"src-components-pages-Press----Press-module---pressList---3_5_Q","linkList":"src-components-pages-Press----Press-module---linkList---3iA2-","gallery":"src-components-pages-Press----Press-module---gallery---11_Zk","pressItem":"src-components-pages-Press----Press-module---pressItem---1EWrf","pressItemTitle":"src-components-pages-Press----Press-module---pressItemTitle---3FG92","pressItemOrigin":"src-components-pages-Press----Press-module---pressItemOrigin---3_ibm","pressItemTime":"src-components-pages-Press----Press-module---pressItemTime---1xq5P","linkItem":"src-components-pages-Press----Press-module---linkItem---3f02-"};

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PageContent = __webpack_require__(31);
	
	var _PageContent2 = _interopRequireDefault(_PageContent);
	
	var _PageHeader = __webpack_require__(32);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Gallery = __webpack_require__(82);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _PressModule = __webpack_require__(424);
	
	var _PressModule2 = _interopRequireDefault(_PressModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PressPage = function PressPage(_ref) {
	  var galleries = _ref.galleries;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_PageHeader2.default, { title: 'Press' }),
	    _react2.default.createElement(_Gallery2.default, {
	      images: galleries['press-wiltshire-living'],
	      gridClassName: _PressModule2.default.gallery,
	      aspectRatio: 1.414
	    }),
	    _react2.default.createElement(
	      _PageContent2.default,
	      null,
	      _react2.default.createElement(
	        'ul',
	        { className: _PressModule2.default.pressList },
	        _react2.default.createElement(
	          'li',
	          { className: _PressModule2.default.pressItem },
	          _react2.default.createElement(
	            'h2',
	            { className: _PressModule2.default.pressItemTitle },
	            _react2.default.createElement(
	              'a',
	              {
	                href: '/assets/southwiltshirelivingarticle.pdf',
	                target: '_blank'
	              },
	              'Keeping Homes Fashionable'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: _PressModule2.default.pressItemOrigin },
	            'Wiltshire Living'
	          ),
	          _react2.default.createElement(
	            'time',
	            { className: _PressModule2.default.pressItemTime },
	            'July 2019'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_Gallery2.default, {
	      images: galleries['press-self-build-design'],
	      gridClassName: _PressModule2.default.gallery,
	      aspectRatio: 1.414
	    }),
	    _react2.default.createElement(
	      _PageContent2.default,
	      null,
	      _react2.default.createElement(
	        'ul',
	        { className: _PressModule2.default.pressList },
	        _react2.default.createElement(
	          'li',
	          { className: _PressModule2.default.pressItem },
	          _react2.default.createElement(
	            'h2',
	            { className: _PressModule2.default.pressItemTitle },
	            _react2.default.createElement(
	              'a',
	              { href: '/assets/selfbuilddesignarticle.pdf', target: '_blank' },
	              'Enhancing The Flow'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: _PressModule2.default.pressItemOrigin },
	            'SelfBuild & Design Magazine'
	          ),
	          _react2.default.createElement(
	            'time',
	            { className: _PressModule2.default.pressItemTime },
	            'June 2016'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: _PressModule2.default.pressItem },
	          _react2.default.createElement(
	            'h2',
	            { className: _PressModule2.default.pressItemTitle },
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'http://www.telegraph.co.uk/finance/property/advice/10520933/Best-20-interior-designers-in-Britain.html',
	                target: '_blank'
	              },
	              'Best 20 Interior Designers in Britain'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: _PressModule2.default.pressItemOrigin },
	            'The Telegraph'
	          ),
	          _react2.default.createElement(
	            'time',
	            { className: _PressModule2.default.pressItemTime },
	            'December 2013'
	          )
	        )
	      ),
	      _react2.default.createElement('hr', null),
	      _react2.default.createElement(
	        'ul',
	        { className: _PressModule2.default.linkList },
	        _react2.default.createElement(
	          'li',
	          { className: _PressModule2.default.linkItem },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://biid.org.uk/users/sue-dann', className: _PressModule2.default.link },
	            'Sue Dann on the British Institute of Interior Design'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: _PressModule2.default.linkItem },
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'http://www.houzz.co.uk/pro/suedann/sue-dann-interiors',
	              className: _PressModule2.default.link
	            },
	            'Sue Dann on Houzz'
	          )
	        )
	      )
	    )
	  );
	};
	
	PressPage.propTypes = {
	  galleries: _propTypes2.default.object
	};
	
	exports.default = PressPage;
	module.exports = exports['default'];

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Press = __webpack_require__(304);
	
	var _Press2 = _interopRequireDefault(_Press);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PressPage = function PressPage(_ref) {
	  var data = _ref.data;
	  var edges = data.allGalleriesJson.edges;
	
	
	  var galleries = {};
	  edges.forEach(function (gallery) {
	    galleries[gallery.node.slug] = gallery.node.images.map(function (image) {
	      return {
	        title: image.title,
	        path: 'press/' + image.path
	      };
	    });
	  });
	
	  return _react2.default.createElement(_Press2.default, { galleries: galleries });
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = PressPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-press-js-9ecb7951431d117d5836.js